import styled from 'styled-components';
import { breakpoints } from '@awaze/design-system.utils.react';
import { InputFacadeStyled, InputFacadeWrappedStyled, } from './input-facade.styles';
export const GroupInputFacadeWrappedStyled = styled.div `
  display: flex;
  flex-direction: column;
  border: ${({ theme }) => `1px solid ${theme.ColorGrey100}`};
  border-radius: 4px;
  overflow: 'hidden';

  @media screen and (min-width: ${breakpoints[0]}px) {
    background-color: ${({ theme }) => theme.ColorWhiteOpacity100};
  }

  ${InputFacadeStyled},
  ${InputFacadeWrappedStyled} {
    width: 100%;
  }

  > ${InputFacadeWrappedStyled} ~ ${InputFacadeWrappedStyled} {
    border-top: ${({ theme }) => `1px solid ${theme.ColorGrey100}`};
  }
`;
//# sourceMappingURL=group-input-facade.styles.js.map